// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"76":"common","902":"pages/mentorPage"}[chunkId] + ".css";
};